export default {
  namespace: 'selectData',
  state: {
    specListApi: [],
  },
  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
